import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const mfaIpWhitelistedQuery = gql`
  query MFAIpWhitelisted {
    mfaIpWhitelisted
  }
`

export const mfaIpWhitelistedKey = getQueryNames(mfaIpWhitelistedQuery)[0]
